import { css } from '@emotion/core';
import styled from '@emotion/styled';

import { CardSection } from '@lightspeed/cirrus-card';
import { spacing } from '@lightspeed/cirrus-tokens/utils';
import Text from '@lightspeed/cirrus-text';

export const VendorDetails = styled(CardSection)`
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
`;

export const AccountContainer = styled(Text, props => ({
  body: props.body,
}))`
  min-width: 10rem;
  padding-right: ${spacing(4)};
`;

export const AddressContainer = styled(Text, props => ({
  body: props.body,
}))`
  min-width: 10rem;
  padding-right: ${spacing(4)};
`;

export const NotesContainer = styled(Text, props => ({
  body: props.body,
  element: props.element,
  dataTest: props.dataTest,
}))`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const breakWord = css`
  word-break: break-all;
`;

export const breakLine = css`
  display: flex;
  width: 100%;
`;
